import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { BrowserService } from 'src/app/services/browser.service';
import { PublicTenantService } from 'src/app/services/public-tenant.service';
import { RedirectService } from 'src/app/services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileMaintenanceGuard {
  constructor(
    private publicTenantService: PublicTenantService,
    private browserService: BrowserService,
    private redirectService: RedirectService
  ) {}

  async canActivate(): Promise<UrlTree | boolean> {
    try {
      await this.publicTenantService.getTenant('maintenance-test');
      return this.redirectService.redirectTo(['/']);
    } catch (error) {
      if (!(error instanceof HttpErrorResponse)) throw error;
      if (error.status === 503) return true;
      return this.redirectService.redirectTo(['/']);
    }
  }
}
